import styled, { css } from 'styled-components';

import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

export const Wrapper = styled.div`
  margin-top: 70px;
  overflow: hidden;
  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD_2}) {
    margin-top: 88px;

    .wrapper {
      display: flex;
      justify-content: center;

      & > section,
      & > div {
        width: 50%;
        margin: 0 22px;
      }
    }
  }
`;

export const Hero = styled.section`
  position: relative;
  padding: 20px 24px 44px;
  background: ${COLOR.WHITE_1};

  .img-background {
    position: absolute;
    width: 430px;
    right: -50px;
    transform: rotate(-10deg);
    top: 480px;
    z-index: 55;
  }

  @media screen and (min-width: 400px) {
    .img-background {
      width: 500px;
      top: 420px;
      right: -70px;
    }
  }
  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    .img-background {
      width: 550px;
      top: 360px;
      right: -80px;
    }
  }

  h1 {
    margin: 0 auto;
    font-size: 24px;
    font-weight: 600;
    line-height: 115%;
    margin-top: 20px;
  }

  h2 {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 18px;
    font-weight: 500;
    margin: 18px 0;

    a {
      display: flex;
      align-items: center;
      width: fit-content;
      text-decoration: underline;
      font-size: 18px;
      font-weight: 500;
      color: ${COLOR.GREEN_1};
      svg {
        margin: 0 0 0 4px;
        font-size: 20px;
      }
      cursor: pointer;
    }

    @media screen and (max-width: 420px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }


  h1, h2 {
    color: ${COLOR.GREY_1};
    line-height: 1.4;
  }

  h3 {
    margin: 1.5rem 0 2rem;
    
    button {
      max-width: 14rem;
    }

    .MuiButton-label {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  }

  @media screen and (min-width: ${BREAKPOINT.MD_2}) {
    .img-background {
      right: -150px;
      width: 700px;
      top: 520px;
    }
    h1 {
      font-size: 38px;
      max-width: 972px;
      margin: 16px 0 0 0;
      text-align: left;
      font-weight: 500;
    }

    h2 {
      font-size: 26px;
      text-align: left;
      margin: 24px 0 18px 0;
      font-weight: 400;
    }
    padding: 56px 90px 110px 90px;
  }

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD_3}) {
    .img-background {
      width: 720px;
      right: -150px;
      top: 470px;
    }
  }  

  @media screen and (min-width: 1100px) {
    overflow: hidden;
    .img-background {
      transform: rotate(5deg);
      right: -200px;
      top: -80px;
      width: 850px;
    }
  }

  /* Tablet-Notebook-3-Desktop */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    .img-background {
      right: 0;
      width: 900px;
    }
  }
`;

export const Card = styled.div`
  position: relative;
  z-index: 100;
  background: ${COLOR.WHITE_4};
  margin: ${({ hero }) => (hero ? '0 0 300px 0' : '44px auto 0 auto')};
  padding: ${({ hero }) => (hero ? '24px 14px' : '32px 24px')};
  max-width: ${({ hero }) => (hero ? '530px' : '600px')};
  box-shadow: 0px 2px 3px rgba(43, 106, 101, 0.3);
  border-radius: 4px;
  .MuiInputBase-root {
    margin: 0;
    width: 100%;
  }

  .MuiButton-root {
    display: flex;
    margin: 10px auto;
    width: 100%;
  }

  h2 {
    margin: 0 0 32px;
    color: ${COLOR.GREY_1};
  }

  h4 {
    font-weight: 500;
    font-size: 18px;
    color: ${COLOR.GREY_1};
    margin: 24px 0 18px;
  }

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD_2}) {
    padding: 45px 55px;
    h4 {
      font-size: 20px;
      margin: 32px 0 24px;
      font-weight: 400;
    }
  }

  @media screen and (min-width: 1100px) {
    margin: ${({ hero }) => (hero && '0 0 100px 0')};
  }
  
`;

export const CheckBoxWrapper = styled.div`
  display: flex;
  margin: 14px 0;
  /* align-items: center; */

  a {
    cursor: pointer;
    font-weight: 600;
    text-decoration: underline;
  }

  .MuiIconButton-root {
    width: 20px;
    height: 20px;
    margin: 0 10px 0 0;
  }

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD_2}) {
    margin: 25px 0;
    p {
      font-size: 16px
    };
  }
`;

export const Box = styled.div`
  background-position: left top;
  background-repeat: no-repeat;

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD_2}) {
    background-size: auto;
    width: 460px; 
    margin: 0 30px;
    padding-top: 30px;
  }
`;

export const Content = styled.section`
  background-color: ${COLOR.WHITE_5};
  padding: ${({ info }) => (info ? '24px 24px 42px 24px' : '60px 24px')};
  background-size: auto;
  background-position: 240px 99%;
  background-repeat: no-repeat;

  h3 {
    font-size: 24px;
    margin: 0;
    color: ${COLOR.BLUE_1};
    font-weight: 500;
    line-height: 1.4;
  }
  
  p {
    font-size: 18px;
    line-height: 1.4;
    margin: 24px 0 32px 0;
  }

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    background-size: auto;
    background-position: right 96%;
    padding: ${({ info }) => (info ? '60px' : '60px 24px')};
    & > div {
      display: flex; 
      justify-content: center;
    }

    h3 {
      font-size: 26px;
    }

    p {
      font-size: 18px;
    }

    .styled-title {
      margin-top: 85px;
    }
  }

  /* Notebook-DeskTop */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    p {
      font-size: 20px;
    }
  }
`;

export const Faq = styled.section`
  background-size: auto;
  background-position: left top 30px; 
  background-repeat: no-repeat;
  padding: 32px 24px;
  h3 {
    font-size: 24px;
    margin: 12px 0;
    color: ${COLOR.CORAL_1};
    font-weight: 500;
  }

  ul {
    margin: 30px 0;
  }

  li {
    position: relative;
    margin: 18px 0;
    font-weight: 500;
  }

  li a {
    display: block;
    text-decoration: underline;
    &:after {
      content: '';
      position: absolute;
      right: 20px;
      width: 0; 
      height: 0; 
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 6px solid ${COLOR.CORAL_1};
    }
  }

  button {
    width: 100%;
    margin: 0;
    background-color: ${COLOR.CORAL_1};
  }

  button:hover {
    background-color: ${COLOR.CORAL_2};
  }

  & > div {
    max-width: 400px;
    margin: 0 auto;
  }

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD_2}) {
    padding: 110px 0px;
    ul {
      margin: 0 0 40px 0;
    }
    h3 {
      text-align: center;
      margin: 0 0 50px 0;
    }

    li {
      background: ${COLOR.WHITE_1};
      box-shadow: 0px 1px 2px 1px rgb(70 77 92 / 20%);
      border-radius: 2px;
      margin: 16px 0;
    }

    li a {
      text-decoration: none;
      padding: 15px 20px;
    }

    a:after {
      right: 24px;
    }
  }
`;

export const Contact = styled.section`
  background: ${COLOR.WHITE_1};
  padding: 30px 24px 20px;

  h3 {
    font-size: 24px;
    color: ${COLOR.CORAL_1};
    font-weight: 500;
    text-align: ${({ form }) => (form ? 'center' : 'left')};
  }

  form {
    max-width: 400px;
    margin: 32px auto;

    button {
      background-color: ${COLOR.CORAL_1};
    }
    button:hover {
      background-color: ${COLOR.CORAL_2};
    }
  }

  h4 {
    color: ${COLOR.GREY_1};
    font-size: 18px;
    margin: 24px 0;
    font-weight: 500;
  }

  li {
    font-size: 16px;
    margin: 10px 0;
    line-height: 1.2;
    font-weight: 300;
  }

  li a {
    text-decoration: underline;
  }

  .MuiButton-root {
    width: 100%;
    margin: 6px 0;
  }

  .social {
    display: flex;

    li {
      margin-right: 24px;
    }
  }

  .MuiInputBase-root {
    width: 100%;
    margin: 6px 0;
  }

  textarea {
    width: 100%;
    margin: 6px 0;
  }

/* Tablet-Notebook */
@media screen and (min-width: ${BREAKPOINT.MD_2}) {
  padding:  ${({ form }) => (form ? '110px 43px' : '110px 38px')};
  form {
    margin: 0 auto;

    textarea {
      height: 118px;
    }

    button {
      margin: 8px 0;
    }
    
  }

  h3 {
    font-size: 26px;
  }

  h4 {
    margin-top: 0;
    font-size: 26px;
  }

  li {
    font-size: 18px;
  }

  & > div {
    margin-top: 50px;
  }

  .social img {
    width: 40px;
  }
}

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD_3}) {
    padding:  ${({ form }) => (form ? '110px 103px' : '110px 38px')};
  }
`;

export const SPCard = styled.div`
  border-radius: 6px;
  margin: 24px auto;
  position: relative;
  text-align: left;
  img {
    width: 100%;
    margin: 32px 0;
  }  

  p {
    font-size: 18px;
    padding: 0;
    line-height: 1.4;
  }

  a {
    position: absolute;
    bottom: 0;
    display: block;
    padding: 14px;
    color: ${COLOR.WHITE_3};
    width: 100%;
    background: ${COLOR.GREEN_1};
    border-radius: 0 0 6px 6px;
    font-weight: 500;
  }

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD_2}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 50px auto 24px auto !important;
    img {
      margin: 24px 0;
      width: 318px;
      height: 204px;
    }
    p {
      font-size: 20px;
    }
    a {
      font-size: 20px;
    }
  }
`;

export const Footer = styled.footer`
  padding: 0 24px 40px;

  h4 {
    color: ${COLOR.GREY_1};
    font-size: 18px;
    margin: 24px 0;
    font-weight: 500;
  }

  p, address {
    font-size: 16px;
    margin: 10px 0;
    line-height: 1.4;
    font-weight: 300;
  }

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD_2}) {
    background: ${COLOR.CORAL_1};
    text-align: center;
    padding: 30px 0;
    margin-top: 60px;

    h4 {
      font-size: 20px;
    }

    *, h4 {
      color: ${COLOR.WHITE_3};
    }

    p, address {
      font-size: 18px;
    }
  }
`;

export const Container = styled.div`
  max-width: 1152px;
  margin: 0 auto;
  position: relative;
  ${({ info }) => info && css`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    div {
      margin: 0;
    }
    div:first-child {
      width: 100%;
      padding-top: 50px;
    }
    /* Tablet-Notebook */
    @media screen and (min-width: ${BREAKPOINT.MD_2}) {
      justify-content: space-between !important;
      div:first-child {
        width: 100%;
        margin-bottom: 50px;
        padding-top: 50px;
      }
      div:nth-child(2) {
        width: 47%;
      }
      div:last-child {
        width: 47%;
      }
    }
  `}
`;
